import React, { useState } from 'react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

type SearchBoxProps = {
  onSearch: (value: string) => void;
  setValue?: (value: React.SetStateAction<string>) => void,
  value?: any
};


export default function SearchBox({ onSearch, value, setValue }: SearchBoxProps): JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setValue(event.target.value);
    onSearch(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value);
  };
  return (
    <form onSubmit={handleSubmit}>
      <InputGroup>
        <InputLeftElement pointerEvents="none" children={<SearchIcon />} />
        <Input
          type="text"
          fontSize={{ base: "xs", lg: "sm" }}
          placeholder="Search..."
          value={value}
          onChange={handleChange}
        />
      </InputGroup>
    </form>
  );
}
